/**
 * For every call that changes something: sent once, and never again by itself.
 *
 * The API layer repeats a failed call up to three more times unless its
 * status is on a short list (see baseApi.ts). That is right for a read and
 * wrong for a write. A connection that drops AFTER the server has done the
 * work looks like a failure from here, and a repeat then does the work a
 * second time: a second request and a second email to the candidate, a second
 * reminder, a review posted twice. A write that failed is said to the person,
 * who decides whether to press the button again.
 *
 * Used as `extraOptions` on each mutation of the Document Centre's two API
 * slices. A test walks both files and fails for a mutation without it.
 */
export const NEVER_RETRIED = { maxRetries: 0 } as const;
